import React, { useCallback } from 'react'
import type { SegmentedOptionsGroupOnValueChangeHandler } from 'LuxKit/SegmentedOptions/SegmentedOptionsGroup'
import SegmentedOptionsGroup from 'LuxKit/SegmentedOptions/SegmentedOptionsGroup'
import SegmentedOption from 'LuxKit/SegmentedOptions/SegmentedOption'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { setTourPriceMode } from 'actions/tour/TourV2Actions'
import { getTourPriceMode } from 'selectors/TourV2/toursSelectors'
import { useIntl } from 'react-intl'

function TourPriceToggle() {
  const tourPriceMode = useAppSelector(getTourPriceMode)
  const dispatch = useAppDispatch()
  const intl = useIntl()

  const handleChange = useCallback<SegmentedOptionsGroupOnValueChangeHandler<'total' | 'perDay'>>((newValue) => {
    dispatch(setTourPriceMode(newValue))
  }, [dispatch])

  return (<form>
    <SegmentedOptionsGroup
      inputsName="tourPriceMode"
      onValueChange={handleChange}
    >
      <SegmentedOption
        checked={tourPriceMode === 'total'}
        value="total"
        title={intl.formatMessage({
          id: 'AYFjGx0CxwVtLnPL7eWf',
          defaultMessage: 'Total price',
          description: 'Option label for total price display mode in the price breakdown',
        })}
      />
      <SegmentedOption
        checked={tourPriceMode === 'perDay'}
        value="perDay"
        title={intl.formatMessage({
          id: '7it-oH6zdk6ZXySA5wZF',
          defaultMessage: 'Price per day',
          description: 'Option label for price per day display mode in the price breakdown',
        })}
      />
    </SegmentedOptionsGroup>
  </form>)
}

export default TourPriceToggle
